(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-coupon-query-params.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-coupon-query-params.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation,
  useHistory = _ReactRouterDOM.useHistory;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const resetWithCouponValues = svs.components.tipsen.engine.actions.resetWithCouponValues;
const _svs$components$tipse = svs.components.tipsen.engine.constants.systems,
  SYSTEM_RSYS = _svs$components$tipse.SYSTEM_RSYS,
  SYSTEM_USYS = _svs$components$tipse.SYSTEM_USYS;
const _svs$components$tipse2 = svs.components.tipsen.engine.utils,
  isValidSportkryssNumber = _svs$components$tipse2.isValidSportkryssNumber,
  generateSportkryssNumber = _svs$components$tipse2.generateSportkryssNumber;
const systems = svs.components.sport.systems;
const _svs$components$tipse3 = svs.components.tipsen.engine.selectors.engineSelectors,
  selectWeeks = _svs$components$tipse3.selectWeeks,
  selectBetAmounts = _svs$components$tipse3.selectBetAmounts,
  selectSportkryssFactors = _svs$components$tipse3.selectSportkryssFactors,
  selectSportkryssBase = _svs$components$tipse3.selectSportkryssBase,
  selectRSystems = _svs$components$tipse3.selectRSystems,
  selectUSystems = _svs$components$tipse3.selectUSystems,
  selectSystemTypes = _svs$components$tipse3.selectSystemTypes,
  selectDefaultReduceModeCount = _svs$components$tipse3.selectDefaultReduceModeCount,
  selectOutcomesEventTypeId = _svs$components$tipse3.selectOutcomesEventTypeId,
  selectReductionSum = _svs$components$tipse3.selectReductionSum,
  selectDrawProductIds = _svs$components$tipse3.selectDrawProductIds;
const _svs$components$sport = svs.components.sport.tipsenShared,
  CouponQueryParams = _svs$components$sport.CouponQueryParams,
  convertStringToSigns = _svs$components$sport.convertStringToSigns,
  convertResultStringToSigns = _svs$components$sport.convertResultStringToSigns,
  convertReductionStringToValue = _svs$components$sport.convertReductionStringToValue;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const feature = svs.core.detect.feature;
const productIds = svs.utils.products.productIds;
const convertSignsFunction = eventTypeId => {
  switch (eventTypeId) {
    case EventTypeId.EVENT_1X2:
      return convertStringToSigns;
    case EventTypeId.RESULT:
      return convertResultStringToSigns;
    case EventTypeId.GOAL_COUNT:
      return convertStringToSigns;
    default:
      throw new Error("Unsupported eventTypeId ".concat(eventTypeId));
  }
};
const useCouponQueryParams = couponId => {
  const location = useLocation();
  const history = useHistory();
  const draw = useCurrentDraw();
  const engineDefinition = useSelector(selectEngineDefinition);
  const maxBetAmount = engineDefinition.maxBetAmount;
  const productId = draw.productId;
  const isMultiDrawsDisabled = feature('ft-hvs-disable-multidraws');
  let weeks = useSelector(selectWeeks);
  if (productId === productIds.FULLTRAFF && isMultiDrawsDisabled) {
    weeks = [1];
  }
  const betAmounts = useSelector(selectBetAmounts);
  const sportkryssFactors = useSelector(selectSportkryssFactors);
  const sportkryssBase = useSelector(selectSportkryssBase);
  const rSystems = useSelector(selectRSystems);
  const uSystems = useSelector(selectUSystems);
  const systemTypes = useSelector(selectSystemTypes);
  const defaultReduceModeCount = useSelector(selectDefaultReduceModeCount);
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const productReductionSum = useSelector(selectReductionSum);
  const dispatch = useDispatch();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    let hasChangedCouponValues = false;
    let hasChangedParameters = false;
    const couponValues = {
      signs: [],
      sportkryssNumber: generateSportkryssNumber(),
      reduceModeCount: defaultReduceModeCount
    };
    const changeCouponValue = (field, value) => {
      hasChangedCouponValues = true;
      couponValues[field] = value;
    };
    const deleteCouponParameter = queryParam => {
      hasChangedParameters = true;
      searchParams.delete(queryParam);
    };
    if (searchParams.has(CouponQueryParams.PARAM_SHARE)) {
      deleteCouponParameter(CouponQueryParams.PARAM_SHARE);
    }
    if (searchParams.has(CouponQueryParams.PARAM_BET_AMOUNT)) {
      const betAmount = Number(searchParams.get(CouponQueryParams.PARAM_BET_AMOUNT));
      if (betAmount && betAmount <= maxBetAmount) {
        changeCouponValue('betAmount', betAmount);
        deleteCouponParameter(CouponQueryParams.PARAM_BET_AMOUNT);
      }
    }
    if (searchParams.has(CouponQueryParams.PARAM_WEEK)) {
      const week = Number(searchParams.get(CouponQueryParams.PARAM_WEEK));
      const weekIndex = weeks.indexOf(week);
      if (weekIndex !== -1) {
        changeCouponValue('week', weekIndex);
        deleteCouponParameter(CouponQueryParams.PARAM_WEEK);
      }
    }
    if (searchParams.has(CouponQueryParams.PARAM_SPORTKRYSS)) {
      const sportkryssAmount = Number(searchParams.get(CouponQueryParams.PARAM_SPORTKRYSS));
      const sportkryssIndex = sportkryssFactors.indexOf(sportkryssAmount / sportkryssBase);
      if (sportkryssIndex !== -1) {
        changeCouponValue('sportkryss', sportkryssIndex);
        deleteCouponParameter(CouponQueryParams.PARAM_SPORTKRYSS);
      }
    }
    if (searchParams.has(CouponQueryParams.PARAM_SPORTKRYSS_NUMBER)) {
      const sportkryssNumber = searchParams.get(CouponQueryParams.PARAM_SPORTKRYSS_NUMBER);
      if (isValidSportkryssNumber(sportkryssNumber)) {
        changeCouponValue('sportkryssNumber', sportkryssNumber);
        deleteCouponParameter(CouponQueryParams.PARAM_SPORTKRYSS_NUMBER);
      }
    }
    if (searchParams.get(CouponQueryParams.PARAM_SIGNS)) {
      const paramSigns = searchParams.getAll(CouponQueryParams.PARAM_SIGNS);
      if (paramSigns.length > 0) {
        const boards = [];
        for (const row of paramSigns) {
          try {
            const convertFunction = convertSignsFunction(eventTypeId);
            boards.push(convertFunction(row, draw.drawEvents.length, eventTypeId, productId));
            deleteCouponParameter(CouponQueryParams.PARAM_SIGNS);
          } catch (_unused) {
            continue;
          }
        }
        changeCouponValue('signs', boards);
      }
    }
    if (searchParams.get(CouponQueryParams.PARAM_REDUCTION)) {
      const reductions = searchParams.getAll(CouponQueryParams.PARAM_REDUCTION);
      if (reductions.length) {
        const boardReduction = [];
        for (const rowReduction of reductions) {
          boardReduction.push(convertReductionStringToValue(rowReduction, productReductionSum, draw.drawEvents.length));
        }
        changeCouponValue('reduction', boardReduction);
      }
      deleteCouponParameter(CouponQueryParams.PARAM_REDUCTION);
    }
    if (searchParams.get(CouponQueryParams.PARAM_SYSTEM_TYPE)) {
      const systemType = searchParams.get(CouponQueryParams.PARAM_SYSTEM_TYPE).toUpperCase();
      if (systemTypes.includes(systemType)) {
        changeCouponValue('systemType', systemTypes.indexOf(systemType));
        deleteCouponParameter(CouponQueryParams.PARAM_SYSTEM_TYPE);
        const system = searchParams.get(CouponQueryParams.PARAM_SYSTEM);
        const systemNum = systems.getSystemNumFromSystemLabel(system);
        if ((systemType === SYSTEM_RSYS || systemType === SYSTEM_USYS) && (rSystems.includes(systemNum) || uSystems.includes(systemNum))) {
          changeCouponValue('rSystem', null);
          changeCouponValue('uSystem', null);
          if (systemType === SYSTEM_RSYS) {
            changeCouponValue('rSystem', systemNum);
          } else {
            changeCouponValue('uSystem', systemNum);
          }
          deleteCouponParameter(CouponQueryParams.PARAM_SYSTEM);
        }
      }
    }
    if (hasChangedCouponValues || hasChangedParameters) {
      if (hasChangedParameters) {
        history.replace({
          search: "?".concat(searchParams)
        });
      }
      if (hasChangedCouponValues) {
        dispatch(resetWithCouponValues(_objectSpread({
          couponId
        }, couponValues)));
      }
    }
  }, [couponId, dispatch, draw.drawEvents.length, eventTypeId, betAmounts, weeks, sportkryssBase, sportkryssFactors, rSystems, uSystems, systemTypes, defaultReduceModeCount, location.search, history, maxBetAmount, productReductionSum, productId]);
};
const deserializeOutcomePairsString = queryString => {
  const params = new URLSearchParams(queryString);
  const outcomePairs = params.get(CouponQueryParams.PARAM_OUTCOME_PAIRS).split(';').map(pairSet => {
    const _pairSet$split = pairSet.split(':'),
      _pairSet$split2 = _slicedToArray(_pairSet$split, 2),
      index = _pairSet$split2[0],
      pairs = _pairSet$split2[1];
    return pairs.split(',').map(pair => pair.split('-'));
  });
  return outcomePairs;
};

const useCouponQueryParamsLite = _ref => {
  var _draw$drawEvents2;
  let draw = _ref.draw;
  const location = useLocation();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    signs = _useState2[0],
    setSigns = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    uSigns = _useState4[0],
    setUSigns = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    mSigns = _useState6[0],
    setMSigns = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    reductions = _useState8[0],
    setReductions = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    outcomePairs = _useState0[0],
    setOutcomePairs = _useState0[1];
  const _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    price = _useState10[0],
    setPrice = _useState10[1];
  const _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    system = _useState12[0],
    setSystem = _useState12[1];
  const eventTypeId = useSelector(selectOutcomesEventTypeId);
  const productReductionSum = useSelector(selectReductionSum);
  useEffect(() => {
    var _draw$drawEvents;
    if (!(draw !== null && draw !== void 0 && (_draw$drawEvents = draw.drawEvents) !== null && _draw$drawEvents !== void 0 && _draw$drawEvents.length)) {
      return;
    }
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get(CouponQueryParams.PARAM_SIGNS)) {
      const paramSigns = searchParams.getAll(CouponQueryParams.PARAM_SIGNS);
      if (paramSigns.length > 0) {
        var _boards$0$signs, _boards$, _boards$0$mSigns, _boards$2, _boards$0$uSigns, _boards$3;
        const boards = [];
        for (const row of paramSigns) {
          try {
            const convertFunction = convertSignsFunction(eventTypeId);
            boards.push(convertFunction(row, draw.drawEvents.length, eventTypeId));
          } catch (_unused2) {
            continue;
          }
        }
        setSigns((_boards$0$signs = boards === null || boards === void 0 || (_boards$ = boards[0]) === null || _boards$ === void 0 ? void 0 : _boards$.signs) !== null && _boards$0$signs !== void 0 ? _boards$0$signs : []);
        setMSigns((_boards$0$mSigns = boards === null || boards === void 0 || (_boards$2 = boards[0]) === null || _boards$2 === void 0 ? void 0 : _boards$2.mSigns) !== null && _boards$0$mSigns !== void 0 ? _boards$0$mSigns : []);
        setUSigns((_boards$0$uSigns = boards === null || boards === void 0 || (_boards$3 = boards[0]) === null || _boards$3 === void 0 ? void 0 : _boards$3.uSigns) !== null && _boards$0$uSigns !== void 0 ? _boards$0$uSigns : []);
      }
    }
    if (searchParams.get('outcomePairs')) {
      const outcomePairs = deserializeOutcomePairsString(location.search);
      setOutcomePairs(outcomePairs);
    }
    if (searchParams.get(CouponQueryParams.PARAM_REDUCTION)) {
      const reductions = searchParams.getAll(CouponQueryParams.PARAM_REDUCTION);
      if (reductions.length) {
        var _boardReduction$;
        const boardReduction = [];
        for (const rowReduction of reductions) {
          boardReduction.push(convertReductionStringToValue(rowReduction, productReductionSum, draw.drawEvents.length));
        }
        setReductions((_boardReduction$ = boardReduction === null || boardReduction === void 0 ? void 0 : boardReduction[0]) !== null && _boardReduction$ !== void 0 ? _boardReduction$ : []);
      }
    }
    if (searchParams.get(CouponQueryParams.PARAM_PRICE)) {
      setPrice(searchParams.get(CouponQueryParams.PARAM_PRICE));
      searchParams.delete(CouponQueryParams.PARAM_PRICE);
    }
    if (searchParams.get(CouponQueryParams.PARAM_SYSTEM)) {
      setSystem(searchParams.get(CouponQueryParams.PARAM_SYSTEM).toUpperCase());
    }
  }, [draw === null || draw === void 0 || (_draw$drawEvents2 = draw.drawEvents) === null || _draw$drawEvents2 === void 0 ? void 0 : _draw$drawEvents2.length, eventTypeId, location.search, price, productReductionSum]);
  return useMemo(() => ({
    mSigns,
    signs,
    reductions,
    outcomePairs,
    uSigns,
    system,
    price
  }), [price, mSigns, outcomePairs, reductions, signs, system, uSigns]);
};
setGlobal('svs.components.tipsen.couponId', {
  useCouponQueryParams,
  useCouponQueryParamsLite
});

 })(window);